import { render } from "./CreateShorterPage.vue?vue&type=template&id=878d0282"
import script from "./CreateShorterPage.vue?vue&type=script&lang=js"
export * from "./CreateShorterPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__